import { useContext } from "react";
import { useAtomValue } from "jotai";
import { editorReadOnlyAtom } from "@/store/editor-jotai";
import { EditorContext } from "@/components/Spotflow/Editor/EditorContext";

// Single source of truth for whether the workflow/agent editor is
// rendering in view-only mode. Components inside the editor tree should
// call this and skip edit-time queries and mutations when it returns
// true.
//
// We read both the context and the atom because:
//   - EditorContext.isReadOnly is set synchronously via the Provider in
//     the workflow editor and is therefore available on the very first
//     render — useRemoteData calls in canvas children get the right
//     value before they fire their fetch.
//   - editorReadOnlyAtom is set from a useEffect (Editor.tsx,
//     assistant page), and is the only signal available to components
//     outside the workflow EditorContext (assistant action modals).
// OR-ing them is safe because both signals only ever indicate
// "view-only" — they can't disagree about edit being allowed.
export function useEditorReadOnly(): boolean {
  const fromAtom = useAtomValue(editorReadOnlyAtom);
  const fromContext = useContext(EditorContext).isReadOnly ?? false;
  return fromAtom || fromContext;
}
